import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import BcTable from '@/components/Table.vue';
// @ts-ignore
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
import BcMask from '@/components/Mask.vue';
// @ts-ignore
import BcDialog, { CBcDialog, CBcDialogForm } from '@/components/Dialog.vue';
let KeyList = class KeyList extends Vue {
    constructor(props) {
        super(props);
        this.headers = [];
        this.desserts = [];
        this.deviceInList = [];
        this.dialog = new CBcDialog(new CBcDialogForm());
        this.dlgInfo = new CBcDialog(new CBcDialogForm());
        this.rules = {};
        this.deviceIdValue = '';
        this.snackbar = new CBcSnackbar();
        this.pagination = {};
        this.maskValue = {};
        this.itemList = [];
        this.deviceSelect = -1;
        this.searchOptions = {
            quickly: '',
            timer: null,
        };
        // 变量在构造函数内部进行声名赋值
        const that = this;
        that.headers = [
            {
                text: '设备ID',
                align: 'start',
                sortable: false,
                value: 'deviceId',
            },
            {
                text: '设备编号',
                align: 'start',
                sortable: false,
                value: 'deviceInfo.deviceId',
            },
            {
                text: '设备类型',
                align: 'start',
                sortable: false,
                value: 'deviceInfo.type',
            },
            {
                text: '设备机型',
                align: 'start',
                sortable: false,
                value: 'deviceInfo.mode',
            },
            {
                text: '加密格式',
                align: 'start',
                sortable: false,
                value: 'keyFormat',
            },
            {
                text: '白名单',
                align: 'start',
                sortable: false,
                value: 'isWhitelist',
            },
            {
                text: '创建时间',
                align: 'start',
                sortable: false,
                value: 'createdAt',
                filter: (value) => value.slice(0, 1),
            },
            {
                text: '更新时间',
                align: 'start',
                sortable: false,
                value: 'updatedAt',
            },
            {
                text: '操作',
                align: 'center',
                sortable: false,
                value: 'action',
            },
        ];
        that.desserts = [];
        that.dialog = {
            visible: false,
            width: '450',
            title: '新增密钥对',
        };
        that.rules = {
            require: (value) => {
                if (!value || (!value && !value.replace(/\s+/g, ''))) {
                    return '该参数为必填项！';
                }
                return true;
            },
        };
        that.pagination = {
            pageCount: 1,
            pageNow: 1,
            pageArr: [5, 10, 20, 50, '所有'],
            everyPageCount: 10,
            sumDetail: 0,
        };
        that.maskValue = {
            isShow: false,
        };
    }
    get havePrivateRight() {
        const that = this;
        return that.userInfo.userName === 'admin';
    }
    created() {
        const that = this;
        that.getDataList();
    }
    async getDataList() {
        const that = this;
        that.maskValue.isShow = !that.maskValue.isShow;
        try {
            const result = await that.axios.get(`/api/device/keys?page=${that.pagination.pageNow}
      &limit=${typeof that.pagination.everyPageCount === 'number' ? that.pagination.everyPageCount : that.pagination.sumDetail}&quickly=${that.searchOptions.quickly || ''}`);
            if (result && result.status === 200) {
                that.maskValue.isShow = !that.maskValue.isShow;
                // 处理获取到的数据，休整并格式化
                that.desserts = result.data.result
                    && result.data.result.map((item) => {
                        if (!that.havePrivateRight)
                            delete item['privateKey'];
                        item.isWhitelist = item.isWhitelist ? '是' : '否';
                        item.createdAt = Vue.filter('dateFormat')(new Date(item.createdAt), 'yyyy-MM-dd hh:mm:ss');
                        item.updatedAt = Vue.filter('dateFormat')(new Date(item.updatedAt), 'yyyy-MM-dd hh:mm:ss');
                        return item;
                    });
                that.deviceInList = result.data.deviceInList || [];
                // 分页信息处理
                that.pagination.sumDetail = result.data.sum;
                const pageCount = Math.ceil(result.data.sum / that.pagination.everyPageCount) || 1;
                that.pagination.pageCount = pageCount;
            }
        }
        catch (e) {
            console.log('error of get device keies', e);
            that.maskValue.isShow = !that.maskValue.isShow;
            that.snackbar.error('密钥列表获取失败，错误为:' + (typeof e === 'object' && JSON.stringify(e)) || e);
        }
    }
    deleteKey(item) {
        const that = this;
        that.dlgInfo.title = '删除密钥';
        that.dlgInfo.autoClose = false;
        that.dlgInfo.text = `删除当前密钥将导致${item.deviceInfo.type}【${item.deviceInfo.name}】数据同步失败，请确认.`;
        that.dlgInfo.rejectedAction = () => {
            that.dlgInfo.visible = false;
        };
        that.dlgInfo.acceptedAction = async () => {
            const url = `/api/device/keys/${item.id}`;
            that.dlgInfo.positive.loading = true;
            that.dlgInfo.persistent = true;
            that.dlgInfo.negative.enabled = false;
            that.axios
                .delete(url)
                .then((res) => {
                that.dlgInfo.persistent = false;
                that.dlgInfo.negative.enabled = true;
                that.dlgInfo.positive.loading = false;
                that.dlgInfo.visible = false;
                that.snackbar.success('密钥删除成功');
                that.getDataList();
            })
                .catch((e) => {
                that.dlgInfo.persistent = false;
                that.dlgInfo.negative.enabled = true;
                that.dlgInfo.positive.loading = false;
                that.dlgInfo.visible = false;
                that.snackbar.error('密钥删除失败');
            });
        };
        that.dlgInfo.visible = true;
    }
    async downloadPublicKey(value, isPublic = true) {
        // 开启弹窗
        const that = this;
        that.maskValue.isShow = !that.maskValue.isShow;
        try {
            const result = value[isPublic ? 'publicKey' : 'privateKey'];
            if (result) {
                that.maskValue.isShow = !that.maskValue.isShow;
                const blob = new Blob([result], { type: 'text/plain;charset=utf-8' });
                const downloadElement = document.createElement('a');
                const href = window.URL.createObjectURL(blob); // 创建下载的链接
                downloadElement.href = href;
                downloadElement.download = `data_transfer_${isPublic ? 'public' : 'private'}_key.pem`; // 下载后文件名
                document.body.appendChild(downloadElement);
                downloadElement.click(); // 点击下载
                document.body.removeChild(downloadElement); // 下载完成移除元素
                window.URL.revokeObjectURL(href);
            }
        }
        catch (e) {
            console.log('error of download publicKey:', e);
            that.maskValue.isShow = !that.maskValue.isShow;
            that.snackbar.error('设备公钥获取失败，错误为:' + (typeof e === 'object' && JSON.stringify(e)) || e);
        }
    }
    addKey(isDialog = false) {
        const that = this;
        that.dialog.visible = !that.dialog.visible;
        if (!isDialog) {
        }
    }
    async confirm() {
        const that = this;
        // 发请求，进行确认
        const require = that.$refs['formDeviceId'].validate(true);
        if (!require)
            return false;
        try {
            const result = await that.axios.post('/api/device/keys', { deviceId: that.deviceSelect });
            if (result) {
                that.snackbar.success('密钥新增成功，可在列表内选择下载！');
                that.dialog.visible = !that.dialog.visible;
                that.getDataList();
            }
        }
        catch (e) {
            that.snackbar.error(e.result + ',' + e.info + '!' || '密钥新增失败！');
        }
    }
    cancel() {
        const that = this;
        that.dialog.visible = !that.dialog.visible;
    }
    searchChange() {
        const that = this;
        clearTimeout(that.searchOptions.timer);
        that.searchOptions.timer = setTimeout(() => {
            that.getDataList();
        }, 1000); // 1秒执行一次获取函数 防抖
    }
    deviceFilter(item, queryText) {
        return (new RegExp(queryText.toUpperCase(), 'i').test(item['deviceNo'].toUpperCase()) || new RegExp(queryText.toUpperCase(), 'i').test(item['name'].toUpperCase()));
    }
};
__decorate([
    Getter
], KeyList.prototype, "deviceList", void 0);
__decorate([
    Getter
], KeyList.prototype, "userInfo", void 0);
KeyList = __decorate([
    Component({
        name: 'key',
        components: {
            BcTable,
            BcDialog,
            BcSnackbar,
            BcMask,
        },
        filters: {
            dateFormat(date) {
                if (!date)
                    return '';
                const dates = new Date(date);
                return dates.format('yyyy-MM-dd hh:mm:ss');
            },
        },
    })
], KeyList);
export default KeyList;
